<template>
  <div class="booking-privileges-overview container">
    <div class="booking-privileges-overview-header">
      <h6 class="title">
        {{ tc("booking.privilegesOverviewTitle") }}
      </h6>
      <p class="subtitle">
        {{ tc("booking.privilegesOverviewSubtitle") }}
      </p>
    </div>
    <div
      v-if="!cartPending && bookingReady"
      class="booking-privileges-overview-body"
    >
      <privilege-overview-card
        v-for="(stay, i) in itemsInCart"
        :key="stay.id"
        :stay="stay"
        :index="i + 1"
      />
    </div>
    <loading-dots v-else />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import PrivilegeOverviewCard from './components/privilege-overview-card.vue'

  export default {
    name: 'PrivilegesOverview',
    components: {
      PrivilegeOverviewCard,
    },
    beforeRouteEnter(to, from, next) {
      next(async (vm) => {
        if (vm.bookingReady) {
          await vm.updateFooterLabel()
        }
        return true
      })
    },
    computed: {
      ...mapState('booking', { bookingReady: 'ready' }),
      ...mapState('cart', ['cartPending']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('cart', ['itemsInCart']),
    },
    watch: {
      async bookingReady(val) {
        if (val) {
          await this.validateEnhancements()
          this.updateFooterLabel()
        }
      },
    },
    async mounted() {
      if (this.bookingReady) {
        await this.validateEnhancements()
      }
    },
    methods: {
      ...mapActions('booking', ['updateNextStepButton']),
      ...mapActions('cart', ['validateEnhancements']),
      async updateFooterLabel() {
        const label = this.tc('steps.checkOut')
        await this.updateNextStepButton({
          label,
          step: 3,
          customClass: 'continue',
        })
      },
    },
  }
</script>
